export default __webpack_public_path__ + "abf244dd38ae7475619b4c678a5271d3.png";